/* @ngInject */
export function AccreditationApprovalProcessController($scope, $rootScope, Notifier,
 ACC_ACCREDITATION_CODE, AccreditationService,
AccountService, $q, $timeout, $mdSidenav, AuthService, SUBJECT_TYPE) {

    $scope.treeViewOptions = {
        showIcon: true,
        expandOnClick: false
    };
    $scope.cursorState = 'wait';

    var ctrl = this;
    ctrl.accreditationSchemaCode = AccreditationService.getCurrentAccreditationFromState();
    ctrl.accStandards = {}; //Accreditation standards hierarchy
    ctrl.basicTree = []; //treeView representation of standard hierarchy
    ctrl.selectedStandard = null; //Currently selected standard in hierarchy or null if nothing is selected

    ctrl.user = {};
    ctrl.selectedUserParentLocation = ""; //uuid
    ctrl.selectedUserParentLocationName = ""; //location name
    ctrl.YEARS = [new Date().getFullYear() - 2, new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1, new Date().getFullYear() + 2];
    ctrl.year = new Date().getFullYear();

    var user = AuthService.getUser();
    ctrl.isAdmin = (user.type == 'Administrator');

    //Find acc standard object in hierarchy based on number, e.g. "1.2.1"
    //Return standard or null if it is not found
    ctrl.findStandardById = function findStandardById(id, hierarchy) {

        if (hierarchy == null) {
            return null;
        }

        try {
            for (var prop in hierarchy) {
                if (hierarchy.hasOwnProperty(prop)) {
                    if ((hierarchy[prop] != null) && (hierarchy[prop].standardId != null) && (hierarchy[prop].standardId == id)) {
                        return hierarchy[prop];
                    }
                    if ((hierarchy[prop].children != null) && (Object.keys(hierarchy[prop].children).length > 0)) {
                        var result = findStandardById(id, hierarchy[prop].children);
                        if (result != null) {
                            return result;
                        }
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
        }

        return null; //nothing is found
    };

    //Function to fetch standards for this accreditation
    ctrl.fetchAccShemaStandards = function (slocUuid) {
        return AccreditationService.fetchAccShemaStandards(ctrl.accreditationSchemaCode, slocUuid)
            .then(function (response) {
                if ((response.status >= 200) && (response.status < 300) &&
                    (response.data.standards != null)) {
                    ctrl.accStandards = response.data.standards;
                    ctrl.basicTree = AccreditationService.createAccreditationSchemaTree(ctrl.accStandards);
                    return 0;
                } else if ((response.status >= 400) && (response.status < 600)) {
                    return $q.reject(response.status);
                } else if ((response.data == null) || (response.data.standards == null)) {
                    return $q.reject(null);
                }
            }, function (error) {
                return $q.reject(error);
            });
    };

    //Function to fetch assesments for this this accreditation schema and site location
    ctrl.fetchAccStandardAssesmentItems = function (slocUuid, year) {
        return AccreditationService.fetchAccShemaAssessments(ctrl.accreditationSchemaCode, slocUuid, year)
            .then(function (response) {
                if ((response.status >= 200) && (response.status < 300) &&
                    (response.data.assessments != null)) {

                    for (var assessment in response.data.assessments) {
                        if (response.data.assessments.hasOwnProperty(assessment)) {
                            var std = ctrl.findStandardById(response.data.assessments[assessment].standardId, ctrl.accStandards);
                            if (std != null) {
                                std.assessment = response.data.assessments[assessment];
                            }
                        }
                    }

                    return 0;
                } else if ((response.status >= 400) && (response.status < 600)) {
                    return $q.reject(response.status); //todo handle null
                } else if ((response.data == null) || (response.data.assessments == null)) {
                    return $q.reject(null);
                }
            }, function (error) {
                return $q.reject(error);
            });
    };

    //Changed selected standard based on new id
    //Return true if new item is selected, otherwise false
    ctrl.selectNewStandard = function (id) {
        if (id == null) {
            return false;
        }
        if ((ctrl.selectedStandard != null) && (ctrl.selectedStandard.standardId == id)) {
            return false;
        } else {
            ctrl.selectedStandard = ctrl.findStandardById(id, ctrl.accStandards);
            return true;
        }
    };

    //Callback from acc-standards-panel, that new standard is selected
    ctrl.newStandardSelected = function (id) {

        //deselect old node in tree view
        if ((ctrl.selectedStandard != null) && (ctrl.selectedStandard.standardId != null)) {
            var tmpNode = ctrl.findStandardById(ctrl.selectedStandard.standardId, ctrl.basicTree);
            if (tmpNode != null) {
                tmpNode.selected = false;
            }
        }

        //select new node
        var tmpNode = ctrl.findStandardById(id, ctrl.basicTree);
        if (tmpNode != null) {
            tmpNode.selected = true;
        }
    };

    ctrl.fetchAccStandardData = function() {
        $scope.cursorState = 'wait';
        ctrl.fetchAccShemaStandards(ctrl.selectedUserParentLocation)
            .then(function (success) {
                ctrl.selectNewStandard(ctrl.selectedUserParentLocation);
                return ctrl.fetchAccStandardAssesmentItems(ctrl.selectedUserParentLocation, ctrl.year);
            }, function (error) {
                if ((typeof error === 'number') && (error >= 500) && (error < 600)) {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_INTERNAL_SERVER_ERROR'));
                } else if ((typeof error === 'number') && (error >= 400) && (error < 500)) {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_PAGE_ERROR'));
                } else {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_FETCH_ERROR'));
                }
            })
            .then(function (success) {
                $scope.cursorState = 'default';
                return 0;
            }, function (error) {
                $scope.cursorState = 'default';
                if ((typeof error === 'number') && (error >= 500) && (error < 600)) {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_INTERNAL_SERVER_ERROR'));
                } else if ((typeof error === 'number') && (error >= 400) && (error < 500)) {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_PAGE_ERROR'));
                } else {
                    Notifier.error($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_FETCH_ERROR'));
                }
            });
    };

    //New standard/sub-standard/sub-sub-standard selected in treeview
    $scope.$on('selection-changed', function (e, node) {
        //node - selected node in tree

        //check if dirty, issue warning
        if ((ctrl.selectedStandard != null) && (ctrl.selectedStandard.standardId != null)
            && (ctrl.selectedStandard.assessment != null) && (ctrl.selectedStandard.assessment.dirty)) {

            $rootScope.confirmationDialog($filter('translate')('ACCREDITATION.TABS.APPROVAL_PROCESS.NOTIFY_UNSAVED_CHANGES'))
                .then(function (result) {
                    //Confirm, continue
                    ctrl.selectNewStandard(node.standardId);
                }, function (error) {
                    return;
                });
        } else {
            ctrl.selectNewStandard(node.standardId);
        }
    });

    //Standard expanded in tree view
    $scope.$on('expanded-state-changed', function (e, node) {
        // node - the node on which the expanded state changed
        // to see the current state check the expanded property
        //ctrl.selectNewStandard(node.standardId);
        //console.log("expanded-state-changed:"+node.name+" expanded:"+node.expanded);
    });

    $scope.$on('LOCATION_SUBJECT_SELECTED', function (event, locationItem) {
        if (locationItem.in_subject_basic_type_code === "slo") {
            $scope.cursorState = 'default';
            ctrl.selectedUserParentLocation = locationItem.in_subject_uuid;
            ctrl.selectedUserParentLocationName = locationItem.in_username_par;
        }
    });

    $scope.$watch('accApprovalCtrl.selectedUserParentLocation', function () {
        if (ctrl.selectedUserParentLocation != "") {
            ctrl.fetchAccStandardData();
        }
    });

    $scope.$watch('accApprovalCtrl.year', function (newYear, oldYear) {

        if ((ctrl.selectedUserParentLocation != "") && (ctrl.year != null)) {
            ctrl.fetchAccStandardData();
        }
    });

    // Side Navigation
    $scope.toggleLeft = buildDelayedToggler('left');

    function debounce(func, wait, context) {
        var timer;

        return function debounced() {
            var context = $scope,
                args = Array.prototype.slice.call(arguments);
            $timeout.cancel(timer);
            timer = $timeout(function() {
                timer = undefined;
                func.apply(context, args);
            }, wait || 10);
        };
    }

    function buildDelayedToggler(navID) {
        return debounce(function() {
            $mdSidenav(navID).toggle();
        }, 200);
    }

    $scope.closeSideNav = function() {
        $mdSidenav('left').close();
    };

    //Load data for parent site location if user belongs to only one site location
    if (user && (user.parentCount === 1) && (user.parents[user.parents.length-1])
        && (user.parents[user.parents.length-1].basicType == SUBJECT_TYPE.SITE_LOCATION)) {

        ctrl.selectedUserParentLocation = user.parents[user.parents.length-1].uuid;
        ctrl.selectedUserParentLocationName = user.parents[user.parents.length-1].name;
        ctrl.fetchAccStandardData();
    }
}
